import type { TFunction } from "i18next";

export const SOCIAL_COMPOSER_PLACEHOLDER_KEY = "social.create_post.whats_on_your_mind";
export const SOCIAL_COMPOSER_PLACEHOLDER_DEFAULT = "What's on your mind? Add #hashtags to organize your posts...";

export const resolveSocialComposerPlaceholder = (t: TFunction): string => {
    const translated = t(SOCIAL_COMPOSER_PLACEHOLDER_KEY, SOCIAL_COMPOSER_PLACEHOLDER_DEFAULT).trim();

    if (translated.toUpperCase() === "TOTO") {
        return SOCIAL_COMPOSER_PLACEHOLDER_DEFAULT;
    }

    return translated;
};
